import axios from "axios";
import config from "_firebase/firebaseconfig.json";
import { getUserToken } from "_firebase/index";

const VITE_DASHBOARD_API_URI = config.VITE_DASHBOARD_API_URI;

export const getImageUrl = async (imageUrl) => {
    const token = await getUserToken();

    const res = await axios.post(
        `${VITE_DASHBOARD_API_URI}/images/getImage?imageUrl=${imageUrl}`,
        {
            imageUrl,
        },
        {
            headers: {
                Authorization: token ? `Bearer ${token}` : "",
            },
            responseType: "arraybuffer",
        }
    );

    const blob = new Blob([res.data]);

    return URL.createObjectURL(blob);
};